<template>
  <v-tab-item :key="4" :value="'tab-4'">
    <v-expansion-panels>
      <v-expansion-panel v-for="item in bills" :key="item.id">
        <v-expansion-panel-header>{{
          item.productName
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>Mã hóa đơn: {{ item.title }}</div>
          <div>Ngày lập hóa đơn: {{ item.createdDate }}</div>
          <div>Tổng tiền: {{ item.total }} đ</div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <br />
  </v-tab-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    contact: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    paidProducts: [],
    tuition: 0
  }),
  methods: {
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('bill', ['fetchBills']),
    save() {
      this.$emit('save', {
        products: this.paidProducts,
        tuition: this.tuition
      })
    },
    cancel() {
      this.notes = this.contact.notes
      this.tuition = this.contact.tuition
      this.$emit('cancel')
    }
  },
  computed: {
    ...mapGetters('product', ['products']),
    ...mapGetters('bill', ['bills']),
    ...mapGetters('app', ['department'])
  },
  watch: {
    contact(contact) {
      this.paidProducts = this.contact.products
      this.tuition = this.contact.tuition
      this.fetchBills({
        contact: this.contact.id,
        department: this.department.id
      })
    }
  }
}
</script>

<style scoped></style>
